import { useContext, useMemo } from 'react'
import {
  buildCruisePromotionPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/cruisePromotionFilterUtils'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import config from 'constants/config'
import { LUXURY_ESCAPES } from 'constants/brands'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import { trackEvent } from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { useIntl } from 'react-intl'

const isLuxuryEscapes = config.BRAND === LUXURY_ESCAPES

interface Props {
  isLuxExclusivePromotion?: Set<string>
  isSpecialOffers?: Set<string>
  onChange: (nextFilters: Record<string, any>) => void
  luxExclusiveFacets: Array<App.CruiseSearchFacetV2Item>
  specialOffersFacets: Array<App.CruiseSearchFacetV2Item>
}

function CruisePromotionFilter({
  isLuxExclusivePromotion,
  isSpecialOffers,
  onChange,
  luxExclusiveFacets,
  specialOffersFacets,
}: Props) {
  const globalSearchState = useContext(GlobalSearchStateContext)
  const intl = useIntl()

  const { leExclusiveItems, hasLuxExclusiveItems } = useMemo(() => {
    return {
      leExclusiveItems: buildCruisePromotionPanelCheckItems(luxExclusiveFacets, intl),
      hasLuxExclusiveItems: luxExclusiveFacets.some(facet => facet.count > 0),
    }
  }, [luxExclusiveFacets, intl])
  const { specialOffersItems, hasSpecialOffersItems } = useMemo(() => {
    return {
      specialOffersItems: buildCruisePromotionPanelCheckItems(specialOffersFacets, intl),
      hasSpecialOffersItems: specialOffersFacets.some(facet => facet.count > 0),
    }
  }, [specialOffersFacets, intl])

  return <div data-testid="cruise-promotion-filter">
    {isLuxuryEscapes && hasLuxExclusiveItems && <FilterPanelCheckboxGroup
      name="isLuxExclusivePromotion"
      items={leExclusiveItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: 'Lux Plus Exclusive',
            type: 'lux_plus_exclusive',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))
        onChange(e)
      }}
      defaultSelected={isLuxExclusivePromotion}
    />}

    {hasSpecialOffersItems && <FilterPanelCheckboxGroup
      name="isSpecialOffers"
      items={specialOffersItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: 'Special Offers',
            type: 'special_offers',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))
        onChange(e)
      }}
      defaultSelected={isSpecialOffers}
    />}
  </div>
}

export default CruisePromotionFilter
